import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Row } from 'antd';

import { getSelectAllLabel } from './utils';
import { SelectionCounter, LinkButton } from './styles';

interface SelectionBarProps {
	selectedCount: number;
	allSelected: boolean;
	disabled?: boolean;
	onToggleAll: () => void;
}

export function SelectionBar({
	selectedCount,
	allSelected,
	disabled = false,
	onToggleAll
}: Readonly<SelectionBarProps>): JSX.Element {
	const selectAllLabel = getSelectAllLabel(allSelected);

	return (
		<Row align="middle" justify="space-between">
			<Col>
				<SelectionCounter>{`${selectedCount} ${I18n.get('selected')}`}</SelectionCounter>
			</Col>
			<Col>
				<LinkButton type="link" disabled={disabled} onClick={onToggleAll}>
					{I18n.get(selectAllLabel)}
				</LinkButton>
			</Col>
		</Row>
	);
}
